import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonsComponent } from '../buttons/buttons.component';

/**
 * Presentational shell for form modals: renders the heading + close button,
 * projects the form body, shows an optional error banner, and renders the
 * Cancel / primary footer buttons. Holds no dialog or form state — the host
 * component wires `closed`/`submitted` and feeds `errorMessage`.
 */
@Component({
  selector: 'app-modal-shell',
  standalone: true,
  imports: [CommonModule, ButtonsComponent],
  templateUrl: './modal-shell.component.html',
  styleUrl: './modal-shell.component.css',
})
export class ModalShellComponent {
  @Input() title = '';
  @Input() primaryLabel = 'Save';
  @Input() cancelLabel = 'Cancel';
  @Input() primaryDisabled = false;
  @Input() errorMessage: string | null = null;

  @Output() closed = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<void>();
}
